module.exports = __webpack_public_path__ + "static/media/news-min.8bde41b3.jpg";